import { render, staticRenderFns } from "./SearchWatchDialog.vue?vue&type=template&id=70ae5e37&"
import script from "./SearchWatchDialog.vue?vue&type=script&lang=js&"
export * from "./SearchWatchDialog.vue?vue&type=script&lang=js&"
import style0 from "./SearchWatchDialog.vue?vue&type=style&index=0&id=70ae5e37&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports